import { render, staticRenderFns } from "./homeDownload.vue?vue&type=template&id=b3db4986&scoped=true&"
import script from "./homeDownload.vue?vue&type=script&lang=ts&"
export * from "./homeDownload.vue?vue&type=script&lang=ts&"
import style0 from "./homeDownload.vue?vue&type=style&index=0&id=b3db4986&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3db4986",
  null
  
)

export default component.exports